import { Callout } from "@octopusdeploy/design-system-components";
import type React from "react";
import { useState } from "react";
import { Text } from "~/components/form";
interface DeleteRunbookProps {
    runbookName: string;
    onChange(canDelete: boolean): void;
}
const DeleteRunbook: React.FC<DeleteRunbookProps> = ({ runbookName, onChange }) => {
    const [confirmationRunbookName, updateConfirmationRunbookName] = useState<string>("");
    const onRunbookNameConfirmation = (confirmationRunbookName: string) => {
        updateConfirmationRunbookName(confirmationRunbookName);
        onChange(confirmationRunbookName.replace(/\s+/g, " ").toLowerCase() === runbookName.replace(/\s+/g, " ").toLowerCase());
    };
    return (<div>
            <Callout title="This is a destructive action" type={"danger"}>
                This action <strong>cannot</strong> be undone. This will permanently delete the <strong>{runbookName}</strong> Runbook and all of its contents, including Runbook Snapshots and Runbook Runs history.
            </Callout>
            <div>
                <p>Please type in the name of the Runbook ({runbookName}) to confirm.</p>
                <Text accessibleName={"Name of runbook to be deleted"} value={confirmationRunbookName} onChange={onRunbookNameConfirmation}/>
            </div>
        </div>);
};
DeleteRunbook.displayName = "DeleteRunbook"
export default DeleteRunbook;
